<script>
    import { user, game, view, send_data, send_request } from "../client.svelte.js";
    import {timestamp, calc_defaultCS} from "../core.js";
    import Upcoming from "../play/Upcoming.svelte";
    import Collapsible from "../elements/Collapsible.svelte";
    import CharCard from "../elements/CharCard.svelte";

    const catLabels = {'part': "vorbereitete NSCs",  'priv': "persönlicher Katalog", 'publ': "öffentlicher Katalog",
                       'hero': "spielbare Helden", 'heroes': "Eigene Helden"}
    const catSorting = {heroes: 1, hero: 2, part: 3, priv: 4, publ: 5}

    let appearing = $state(false)

    let heroes = $derived(Array.from(game.personas.values())
	    .filter(pers => pers.affil === 'fellow' && pers.position)
	    .map(pers => ({ID: pers.ID, name: pers.name,
		               activity: game.activities.get(pers.activity) ?? {},
		               previous: game.activities.get(pers.finisheds.at(-1))?.end ?? 0}) ) )

    let upcomings = $derived(view.incidents
	    .filter(infl => (infl.status === 'upcoming' && infl.time > game.time ))
	    .toSorted((a,b) => a.time - b.time))

    let groupedCharacters = $derived(
	    Object.fromEntries(
		    Object.entries(
			    Object.groupBy(
				    user.characters.values()
					    .filter((char) => !char.ZUB || char.ZUB !== 'Hero')
					    .toArray()
					    .toSorted((char1,char2) => char1.name.localeCompare(char2.name))
				    , (char) => (char.rubric === view.adventure?.ID) ? 'part' : char.cat))
			    .map(([cat, list]) => [cat, (cat === 'publ') ? Object.groupBy(list, ({race}) => race) : (cat === 'priv') ? Object.groupBy(list, ({rubric}) => rubric ?? "") : {"": list}])
			    .toSorted(([cat1, list1], [cat2, list2]) => catSorting[cat1] - catSorting[cat2])
			    .map(([cat, list]) => [catLabels[cat] ?? cat, list]) ) )

    // $inspect(`MASTER: heroes`, heroes)


    function switch_appearing() {
		    appearing = !appearing
    }

    /** lets the dragged character appear as new fighter at the dropped location; non-variants get a variant first */
	  async function deploy_fighter(position, e) {
		    let variant = this
		    if (this.ZUB !== 'Variant') {
				    const data = {templID: this.ID, callsign: calc_defaultCS(this.name, this.isIndividuum),
				                  name: this.name, level: this.level, affiliation: this.affiliation, individuum: this.isIndividuum}
				    console.log(`MASTER: Create new variant ${data.callsign} based on ${this.ID}`, data)
				    const response = await send_data(`/variant/_`, data, 'POST')
				    variant = response?.characters?.[0]
				    if (!variant)  return
		    }
		    console.log(`MASTER: Variant ${variant.ID} appears at ${position}`)
		    const appearData = {instruct: 'APPEAR', character: variant.ID, callsign: variant.CS, target: position}
				const ranks = Object.entries(variant.ranks ?? {}).toSorted(([r1,d1], [r2,d2]) => d1 - d2).map(([rank,delta]) => rank)
		    if (ranks.length > 1) {		// let user decide on rank of new fighter
				    const options = {'Auftauchen':
						    ranks.map((rank, i) => Object.assign({label: rank, rank: i + 1, socket: 'instruct'}, appearData)) }
				    view.show_dialog('options', {coord: {x: e.clientX, y: e.clientY}, options: options})
		    } else {		// individuum appears directly, specimen with default rank
				    send_request('instruct', Object.assign(appearData, {rank: (variant.isIndividuum) ? null : 1}))
		    }
    }
</script>


<!------------------------------- HTML ------------------------------------->

<div class=masterControl class:masterView={user.isMaster} class:playerView={!user.isMaster}>
	<!--- hero activity info box --->

  <h3>Handlungen der Helden</h3>
	<div class=heroActs data-help="heroActs">
        {#each heroes as hero}
            <span>{hero.name}</span>
            <span>{hero.activity?.action ?? "–"}</span>
            <span class="time">{timestamp(hero.activity?.begin ?? hero.previous)}</span>
        {/each}
	</div>

    <button data-help="newfighter" onclick={switch_appearing} style="background-color: revert">Neuen Kämpfer auftauchen lassen</button>

    {#if appearing}
	    <div class=charPicker>
		    {#each Object.keys(groupedCharacters) as cat}
			    <Collapsible header={cat} >
				    {#each Object.keys(groupedCharacters[cat]) as group}
					    <Collapsible header={group} tag=h3>
						    {#each groupedCharacters[cat][group] as character (character.ID)}
							    <CharCard data={character} mode='deploy' onselect={() => {}}
							              onaction={{deploy: deploy_fighter.bind(character)}} />
						    {/each}
					    </Collapsible>
				    {/each}
			    </Collapsible>
		    {/each}
	    </div>
    {/if}

	<div id="upcomingBox" data-help="upcoming">
        {#each upcomings as upcoming (upcoming.ID)}
            <Upcoming {upcoming} on:select />
        {/each}
	</div>

</div>


<!------------------------------- STYLES ------------------------------------->

<style lang="sass">

	.masterControl
		margin-top: 1em

		h3
			text-align: center

	.heroActs
		margin: 1em
		display: grid
		grid-template-columns: 1fr 2fr 5ch

		.time
			text-align: right

	.charPicker
		position: relative
</style>
